// REACT
import React, { RefObject, CSSProperties } from 'react'

// ESTILOS
import Styles from './CloseButton.module.css'

// PROPIEDADES
interface ButtonProps {
	className?: string
	style?: CSSProperties
	action?: () => any
	btnRef?: RefObject<HTMLButtonElement>
}

const CloseButton: React.FC<ButtonProps> = (props: ButtonProps) => {
	return (
		<button
			style={props.style}
			ref={props.btnRef}
			className={`${Styles.btn} ${props.className}`}
			onClick={props.action}>
			<i className='lni lni-close' />
		</button>
	)
}

export default CloseButton
